import { POPULATE_CATEGORIES, POPULATE_LEVERANCIERS, TOGGLE_CATEGORY_FILTER, UPDATE_SEARCH_TERM } from "./types";

export const populateCategories = (categories) => {
    return {
        type: POPULATE_CATEGORIES,
        categories
    };
}

export const populateLeveranciers = (leveranciers) => {
    return {
        type: POPULATE_LEVERANCIERS,
        leveranciers
    }
}

export function toggleCategoryFilter(category, checked) {
    return {
        type: TOGGLE_CATEGORY_FILTER,
        category, 
        checked
    }
}

export function updateSearchTerm(term) {
    return {
        type: UPDATE_SEARCH_TERM,
        term   
    }
}